<div class="mat-elevation-z2">
    <table mat-table [dataSource]="dataSource" matSort class="w-100 tables">
        <!-- First Name Column -->
        <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'home.name' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{element.firstName}}</td>
        </ng-container>

        <!-- Last Name Column -->
        <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'home.lastname' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{element.lastName}}</td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'home.email' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{element.email}}</td>
        </ng-container>

        <!-- Company Name Column -->
        <ng-container matColumnDef="requestForCompanyName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'home.request_company_name' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
                {{element.requestForCompanyName}}
            </td>
        </ng-container>

        <!-- Request Date Column -->
        <ng-container matColumnDef="requestDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'home.request_date' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element.createdAt | date: 'dd.MM.yyyy'}}
            </td>
        </ng-container>

        <ng-container matColumnDef="details">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let element">
                <div class="d-flex justify-content-end align-items-center">
                    <div class="d-flex justify-content-start align-items-center">
                        <div *ngIf="checkSyncStatus(element)" class="loader"></div>
                    </div>
                    <div
                        class="btn btn-xs-small"
                        [ngClass]="{
                            'btn-second': checkSyncStatus(element),
                            'btn-primary': !checkSyncStatus(element)
                        }"
                        (click)="viewRegistrationRequest(element.id)"
                    >
                        details
                    </div>
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let element" style="text-align:center">
                <div
                    *ngIf="!element.magentoCustomerId"
                    class="btn btn-danger btn-xs-small-danger"
                    (click)="deleteUser(element.id)"
                >
                    {{ 'user.btn_delete' | translate }}
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator
        [pageSizeOptions]="[10, 20]"
        showFirstLastButtons
    ></mat-paginator>
</div>
<div *ngIf="userDeleted" class="modal-container" (click)="closeModal()">
    <div class="modal-content text-center">
        <div class="close-btn">
            <img src="../../../assets/icons/close.png" alt="" />
        </div>
        <h2>{{ modalText | translate }}</h2>
    </div>
</div>
